import React, { useState, useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Modal, IconButton, Button, Fade, Backdrop } from "@material-ui/core";
import { Close, Visibility } from "@material-ui/icons";
import { useTranslation } from "react-i18next";

import styles from "./ImagePreviewStyles";
import ImagePreviewContent from "./ImagePreviewContent";

const ImagePreview = ({
  classes,
  imageUrl,
  imageFile,
  phoneWidth,
  phoneHeight,
  tabletWidth,
  tabletHeight,
  twoPreviewsPerTab,
  titleOneImageInfo,
  titleTwoImageInfo,
  backgoundSize = "cover",
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button
        className={classes.previewButton}
        onClick={handleOpen}
        startIcon={<Visibility />}
      ></Button>

      <Modal
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
          className: classes.backdrop,
        }}
      >
        <Fade in={open}>
          <div className={classes.modalContent}>
            <IconButton
              className={classes.closeButton}
              onClick={handleClose}
              size="small"
            >
              <Close />
            </IconButton>
            <ImagePreviewContent
              classes={classes}
              imageUrl={imageUrl}
              imageFile={imageFile}
              phoneWidth={phoneWidth}
              phoneHeight={phoneHeight}
              tabletWidth={tabletWidth}
              tabletHeight={tabletHeight}
              titleOneImageInfo={titleOneImageInfo}
              titleTwoImageInfo={titleTwoImageInfo}
              twoPreviewsPerTab={twoPreviewsPerTab}
              backgoundSize={backgoundSize}
            />
          </div>
        </Fade>
      </Modal>
    </>
  );
};

export default withStyles(styles)(ImagePreview);
